/* @format */
import { api } from '@/scripts/api';

export const BrandingService = {
    get(filter) {
        return new Promise((resolve, reject) => {
            const service = `/api/Brandings/Magic?${filter}`;

            api.get(service).then(resolve).catch(reject);
        });
    },

    patch(id, payload) {
        return new Promise((resolve, reject) => {
            const service = `/api/Brandings/${id}`;

            api.patch(service, payload).then(resolve).catch(reject);
        });
    },

    post(payload) {
        return new Promise((resolve, reject) => {
            const service = '/api/Brandings';

            api.post(service, payload).then(resolve).catch(reject);
        });
    },

    delete(id) {
        return new Promise((resolve, reject) => {
            const service = `/api/Brandings/${id}`;

            api.delete(service).then(resolve).catch(reject);
        });
    },
};
